export default Object.freeze({
  Reports: 326,
  User: 181,
})
